export const BASE_PATH_PREFIX = '/';

export const LOGIN = '/login';
export const LOGIN_PATH = '/login';
export const LOGIN_CALLBACK_PATH = '/login/callback';
export const RESET_PASSWORD = '/reset-password';
export const DISCLAIMER = '/disclaimer';

export const COMMUNICATION = '/communication';

export const USERS = `/user-management`;
export const USER_DETAILS = `${USERS}/details`;

export const CONTENT_MANAGEMENT = `/content-management`;
export const CONTENT_MANAGEMENT_DETAILS = `${CONTENT_MANAGEMENT}/details`;

export const DATA_CENTER_AUTOMATION = `/data-center-automation`;
export const DATA_CENTER_AUTOMATION_DETAILS = `${DATA_CENTER_AUTOMATION}/details`;

export const INVESTORS_MANAGEMENT = `/investor-management`;
export const INVESTORS_MANAGEMENT_DETAILS = `${INVESTORS_MANAGEMENT}/details`;

export const HOLDCO_MANAGEMENT = '/holdco-management';

export const DOCUMENT_MASTER = `/document-master`;
export const DOCUMENT_MASTER_DETAILS = `${DOCUMENT_MASTER}/details`;

export const MY_HOLDINGS = `/my-holdings`;

export const MY_PROFILE = `/my-profile`;

export const MY_DOCUMENTS = `/my-documents`;

export const CONTACTUS = `/contactus`;

// export const NOTIFICATIONS = `/notifications`;
// export const NOTIFICATION_DETAILS = `${NOTIFICATIONS}/details`;
// export const DATA_UPLOAD_CENTERS = `/data-upload-center`;
// export const DATA_UPLOAD_CENTER_DETAILS = `${DATA_UPLOAD_CENTERS}/details`;
// export const TRANSACTIONS_PATH = '/transactions';
// export const ADMIN_PATH = '/admin';
// export const INVESTMENT_PATH = '/investment';
// export const INVESTORS_PATH = '/investors';
// export const INVESTOR_BULK_UPDATE_DEMO = `/bulk-update-demo`;
// export const INVESTOR_BULK_UPDATE = `/bulk-update`;
// export const VESTING_PATH = `/vesting`;
// export const PORTFOLIO_PATH = `/portfolio`;
// export const CONFIGURATION = `/configuration`;
// export const HOLDCO_MANAGEMENT_DETAILS = `${HOLDCO_MANAGEMENT}/details`;
// export const HOLDCO_MANAGEMENT_EDIT = `${HOLDCO_MANAGEMENT}/edit`;